import { TableCell } from "@mui/material";
import { transformVersionRef } from "../../helpers";
import { CopyButton } from "../../../Components/Buttons/CopyButton";
import styles from "./styles.module.css";

interface Props {
  versionRef: string;
  id: string;
}

export const VersionRefCell = ({ versionRef, id }: Props) => {
  return (
    <TableCell className={styles["ref-cell"]}>
      <span>{transformVersionRef(versionRef, id)}</span>
      <CopyButton
        copyContent={`${versionRef}:ID_${id}`}
        className={styles["copy-button"]}
      />
    </TableCell>
  );
};
